import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import MuiButton from "Components/MuiButton/MuiButton";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import Input from "Components/Input/Input";
import { DialogActions } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import * as R from "ramda";
import { read } from "Helpers/LocalStorage";
import showNotify from "Helpers/Notify";
import {
  editSettingGlass,
  getComboGlass_Id,
  getComboGlassGroup,
} from "Stores/actions/properties/ShopAction";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import * as Icons from "react-bootstrap-icons";

export default function EditGlass({ row }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [checkValid, setCheckValid] = useState(false);

  const [controls, setControls] = useSetState({
    name: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
    },
    glassGroup: {
      type: "select",
      selectItems: [],
      value: null,
    },
    glass: {
      type: "select",
      selectItems: [],
      value: null,
    },
    description: {
      type: "text",
      value: "",
      validation: {
        required: false,
      },
    },
  });

  const handleDialog = () => setOpenDialog(!openDialog);

  const onEnter = async () => {
    onClear();
  };

  const onClear = async () => {
    setCheckValid(true);
    setFormValid({ name: true });
    setControls({ name: { value: row.ShowName } });
    setControls({ description: { value: row.Description } });
    await get_GlassGroups();
  };

  const get_GlassGroups = async () => {
    setLoading(true);
    const data = await dispatch(
      getComboGlassGroup({
        KeyUser: read("userKey"),
        KeyGroup: read("groupKey"),
      }),
    );
    setControls({ glassGroup: { selectItems: data } });
    setControls({
      glassGroup: { value: data.find((i) => i.Id === row.GroupId) },
    });
    if (data && data.length !== 0) await get_Glasses_In_Group(row.GroupId);
    setLoading(false);
  };

  const get_Glasses_In_Group = async (Id) => {
    setLoading(true);
    const data = await dispatch(
      getComboGlass_Id({
        KeyUser: read("userKey"),
        KeyGroup: read("groupKey"),
        idGroupProduct: Id,
      }),
    );
    setControls({ glass: { selectItems: data } });
    setControls({
      glass: { value: data.find((i) => i.Id === row.ProductGlassId) },
    });
    setLoading(false);
  };

  const onExit = () => {
    setOpenDialog(false);
  };

  const setValue = async (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
    if (controlName === "glassGroup") get_Glasses_In_Group(value.Id);
  };

  const onFinish = async (e) => {
    e.preventDefault();
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      const { glass, name, description } = controls;
      try {
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          productGlassId: glass.value.Id,
          name: name.value,
          description: description.value,
          id: row.Id,
        };
        setLoading(true);
        await dispatch(editSettingGlass(data));
        onExit();
        setLoading(false);
      } catch (e) {
        showNotify({
          text: t("correctFormDataRequired"),
          customClass: "error",
        });
      }
    } else {
      setCheckValid(true);
    }
  };

  return (
    <>
      <ActionFormatter
        title={<Translator id="virayesh" />}
        icon={<Icons.Pencil size={17} />}
        className="warning-fill"
        onClick={handleDialog}
        disabled={!read("settingShopGlass")?.accessUpdate}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        TransitionProps={{ onEnter: onEnter, onExit: onExit }}
        onClose={handleDialog}
        fullWidth
        maxWidth="xs"
      >
        <div>
          <div className="dialogHeader">
            <p>{<Translator id={"glassEdit"} />}</p>
          </div>
          <DialogContent id="content-dialog-manager">
            <BackDropLoading loading={loading} />
            <Grid container spacing={2}>
              {Object.keys(controls).map((key, index) => {
                return (
                  <Grid item xs={12} key={key + index}>
                    {controls[key].type === "select" && (
                      <MuiAutoComplete
                        options={controls[key].selectItems}
                        label={<Translator id={key} />}
                        value={controls[key].value}
                        id={key}
                        onChange={autoCompleteHandler}
                      />
                    )}
                    {controls[key].type === "text" && (
                      <Input
                        setValue={setValue.bind(this)}
                        value={controls[key].value}
                        name={key}
                        validation={controls[key].validation}
                        label={<Translator id={key} />}
                        type="text"
                        checkValid={checkValid && !formValid[key]}
                      />
                    )}
                  </Grid>
                );
              })}
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
              loading={loading}
              color="primary"
              title={<Translator id="button_save" />}
              onClick={onFinish}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </div>
      </Dialog>
    </>
  );
}
